<div class="sk-grid-first sk-p-12" *ngFor="let grid of [0, 1]">
    <div class="sk-grid-evets">
        <div class="sk-line1 sk-h-12 sk-b-rad8"></div>
        <div class="sk-grid-lines sk-h-12 sk-b-rad8" *ngFor="let i of [0, 1]"></div>
    </div>
    <div class="sk-grid-markets">
        <div class="sk-grid-left">
            <div class="sk-grid-teams" *ngFor="let team of teams">
                <div class="sk-grid-{{ team.team1 }} sk-h-12 sk-b-rad8"></div>
                <div class="sk-grid-{{ team.team2 }} sk-h-12 sk-b-rad8"></div>
            </div>
            <div class="sk-grid-teams" *ngIf="isMobileOrRacingForecast">
                <div class="sk-grid-team3 sk-h-12 sk-b-rad8"></div>
                <div class="sk-grid-team4 sk-h-12 sk-b-rad8"></div>
            </div>
        </div>
        <div class="sk-grid-right">
            <div class="sk-grid-right-team sk-b-rad4" *ngFor="let i of [0, 1, 2, 3]"></div>
            <div class="sk-grid-right-team sk-b-rad4" *ngIf="isMobileOrRacingForecast"></div>
        </div>
    </div>
</div>
